import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from 'store/useAuthStore'

const PublicRouter = () => {
    // store
    const { isLogin } = useAuthStore()

    // 인증된 경우 메인 페이지로 리다이렉트
    if (isLogin) {
        return <Navigate to="/" replace />
    }

    // 권한이 있으면 자식 라우트를 렌더링
    return <Outlet />
}

export default PublicRouter
